import SkirtingBoardsMeasurementValues from "./SkirtingBoardsMeasurementValues";

export default SkirtingBoardsMeasurementValues